import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    CardBody,
    CardHeader,
    Divider,
    FormControl,
    FormLabel,
    Input,
    Button,
    VStack,
    useToast,
} from "@chakra-ui/react";
import { useFetchBlocksReserve, ReserveSetting } from "../../../hooks/blocksReserve/useFetchBlocksReserve";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";

export const EditBlocksReserveSetting: React.FC = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const { reserveSetting, isLoading, registerReserve, fetchReserveSetting } = useFetchBlocksReserve();
    const navigate = useNavigate();
    const toast = useToast();

    const [id, setId] = useState("");
    const [password, setPassword] = useState("");

    // コンポーネントマウント時に既存データを取得
    useEffect(() => {
        if (restaurantId) {
            fetchReserveSetting(restaurantId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [restaurantId]);

    // reserveSetting更新時にフォーム値を更新
    useEffect(() => {
        console.log("reserveSetting", reserveSetting);
        if (reserveSetting) {
            // APIのレスポンス構造に合わせてプロパティ名を設定
            // TypeScriptのオプショナルチェーン(?.)を使用してsafe accessする
            setId(reserveSetting?.reserve_id || reserveSetting?.id || "");
            setPassword(reserveSetting?.password || "");
        }
    }, [reserveSetting]);

    const handleSubmit = async () => {
        if (!restaurantId) return;
        
        if (!id || !password) {
            toast({
                title: "入力エラー",
                description: "IDとパスワードを入力してください",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        try {
            await registerReserve(restaurantId, id, password);
            toast({
                title: "登録成功",
                description: "BLOCKsリザーブ設定が保存されました",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
            // 登録成功後、設定一覧画面に遷移
            navigate(`/admin/restaurants/${restaurantId}/settings/blocks-reserve`);
        } catch (error) {
            console.error("登録に失敗しました", error);
            toast({
                title: "登録エラー",
                description: "設定の保存中にエラーが発生しました",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    if (isLoading) return <CircularLoading />;

    return (
        <DarkShadowCard w="100%">
            <CardHeader pb={0}>
                <CardHeading icon={<SettingsIcon />} heading="BLOCKsリザーブ設定" />
            </CardHeader>
            <CardBody>
                <VStack align="start" spacing={4} w="100%">
                    <Divider my={0} />
                    <FormControl w="100%">
                        <FormLabel>ID</FormLabel>
                        <Input
                            value={id}
                            onChange={(e) => setId(e.target.value)}
                            placeholder="IDを入力"
                        />
                    </FormControl>
                    <FormControl w="100%">
                        <FormLabel>パスワード</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="パスワードを入力"
                        />
                    </FormControl>
                    <Button colorScheme="teal" onClick={handleSubmit}>
                        登録
                    </Button>
                </VStack>
            </CardBody>
        </DarkShadowCard>
    );
};